"use strict";

if (typeof window !== "undefined" && window.React) {
  module.exports = window.React;
} else {
  module.exports = require("react");
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty/dist/node/lib/react.js
 ** module id = 464
 ** module chunks = 0
 **/